import React from 'react';
import { connect } from 'react-redux';

import { withError } from '../../shared/components/error-boundary';

import { trackCustomMetric } from '../../metrics/track-params';

const withPageComponents = (Component, options) => {
    const { components = [], device, storeDomain, siteConfig, location } = options || {};

    const pageComponents = props => {
        return <Component {...props} />;
    };

    const mapStateToProps = (state, ownProps) => {
        const { slugInfo, storeDomain: storeDomainState } = state;
        let propObj = components.reduce(
            (r, c) => {
                const cmp = slugInfo.components[c];
                if (cmp) {
                    r[c] = cmp;
                }
                return r;
            },
            { category: slugInfo.category, vanityUrl: slugInfo.vanityUrl }
        );
        if (device) {
            propObj.device = state.ui.device;
            propObj.width = state.ui.width;
        }
        if (storeDomain) {
            propObj.storeDomain = storeDomainState;
        }
        if (siteConfig) {
            propObj.siteConfig = state.siteConfig;
        }
        if (location) {
            propObj.location = state.router.location;
        }
        return propObj;
    };

    const mapDispatchToProps = dispatch => {
        //TODO: add action for fetching components async
        return {
            trackCustomMetric: (eventName, params) => dispatch(trackCustomMetric(eventName, params)),
        };
    };

    return connect(mapStateToProps, mapDispatchToProps)(withError(pageComponents));
};

export default withPageComponents;
